import React from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import Table from '../../widgets/tables/Table';
import WaitDialog from '../../widgets/WaitDialog';

import SendMailWidget from '../../widgets/SendMailWidget';
import SendNotificationWidget from '../../widgets/SendNotificationWidget';
import GetStudenti from '../../services/getStudenti';
import DeleteStudente from '../../services/deleteStudente';
import addNotification from '../../services/addNotification';
import sendMail from "../../services/sendMail";
import saveFile from "../../services/saveFile";
import getSetting from "../../services/getSetting";
import Utils from "../../utils/utils";
import { NineCellLoading } from 'react-loadingg';
import NewStudentWidget from "../../widgets/NewStudentWidget";
import translateString from "../../utils/Locales";

let t = translateString;

export default class Studenti extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.options = [
      { value: 'All', label: 'All' }
    ]

    this.selectRef = React.createRef();

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: true,
      addElementVisible: false,
      waitDialogVisible: false,
      mailCompaniesList: []
    }

    this.grid = 2;

    this.pdfElements = [];

    this.studenti = [];
    this.brokerId = undefined;

    const cookies = new Cookies();
    this.dbPath = cookies.get('db_path', { path: '/' });
    var strJson = JSON.stringify({list: []});
    cookies.set('checksList', strJson, { path: '/' });
    
    this.sendMailRef = React.createRef();
    this.sendNotificationRef = React.createRef();

    this.state = {
        isLoading: true,
        newStudentVisible: false,
    };

  }

  async reload(){
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    
    this.studenti = await GetStudenti(username, token);
   
    this.setState({ isLoading: false });
  }

  async componentDidMount(){
    await this.reload();

  }
ì
  render () {

    var headCells = [
      { id: 'nome', numeric: false, disablePadding: true, label: t('nome') },
      { id: 'cognome', numeric: true, disablePadding: false, label: t('cognome') },
      { id: 'mail', numeric: true, disablePadding: false, label: 'Mail' },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];

    this.searchCols = ['nome', 'cognome', 'mail'];

    const cookies = new Cookies();

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={t('studenti')} button={t('aggiungi')} onClick={() => {
          //window.location.href =  '/' + this.dbPath + '/#/app/addStudente';
          this.setState({ newStudentVisible: true });
        }}/>
        <div style={{ display: 'flex', marginTop: -30, marginBottom: 10, marginLeft: 5 }}>
                <img alt="" src={ require('../../images/question_icon.png') } style={{ width: 10, height: 10, marginRight: 5, marginTop: 1 }} />
                <p style={{ fontSize: 12, color: 'darkgray', maxWidth: '80%' }}>{t('studenti_info')}</p><br/>
          </div>

        <Table headCells={headCells} searchCols={this.searchCols} calendar={false} pdf={true} excel={false} mail={true} phone={true} rows={this.studenti}
      
        onEventClick={(row) => {
          cookies.set('currentStudente', row, { path: '/' });
          window.location.href = '/' + this.dbPath + '/#/app/editStudente';
        }}

        onPdfClicked={(row) => {
            cookies.set('requestedStudent', row, { path: '/' });
            window.location.href =  '/' + this.dbPath + '/#/app/pdfSingleStudent';
        }}

        onSendMail={(id) => {
          this.sendMailRef.current && this.sendMailRef.current.reset();
          this.setState({sendMailVisible: true, sendMailUserId: id}); 
        } }
        onSendNotification={(id) => {
          this.sendNotificationRef.current && this.sendNotificationRef.current.reset();
          this.setState({sendNotificationVisible: true, notificationUser: id}); 
        } }

        onDelete={async (id) => {
          if (window.confirm(t('elimina_studente')) == false) return;

          const cookies = new Cookies();
          const username = cookies.get('username', { path: '/' });
          const token = cookies.get('token', { path: '/' });
          await DeleteStudente(username, token, id);
          this.reload();
        }}

        onElementCheck={async (companyId) => {
          const cookies = new Cookies();

          var json = cookies.get('checksList', { path: '/' });
          var checksList = json.list;
          var index = checksList.indexOf(companyId);
          if (index != -1)
            checksList.splice(index, 1);
          else 
            checksList.push(companyId);

          cookies.set('checksList', JSON.stringify({list: checksList}), { path: '/' });
        }}

        />

        {this.elementPdf ? this.elementPdf : null}
        <SendMailWidget 
          ref={this.sendMailRef}
          show={this.state.sendMailVisible} 
          onClose={() => this.setState({sendMailVisible: false})}
          onSend={async (subject, body, file) => {
            
            const cookies = new Cookies();
            const username = cookies.get('username', { path: '/' });
            const token = cookies.get('token', { path: '/' });
            this.mail = await getSetting(username, token, 'sendingMailAddress');
            if (this.mail === '') {
              Utils.showError(t('errore_manca_mail'));
              return;
            }
            this.mailName = await getSetting(username, token, 'sendingMailPassword');
            if (this.mailName === '') {
              Utils.showError(t('errore_manca_mail'));
              return;
            }

            var studente = this.studenti.find(s => s.id == this.state.sendMailUserId);
            studente.mail = studente.mail.trim();
            studente.mail2 = studente.mail2.trim();
            
            if (file != undefined){
              this.filePath = await saveFile(username, token, file.name, file.base64);
            }

            if (studente.mail != '' && Utils.validateEmail(studente.mail) == false){
              alert (t('l_indirizzo') + " " + studente.mail + t('non_valido'));
              return;
            }
            if (studente.mail2 != '' && Utils.validateEmail(studente.mail2) == false){
              alert (t('l_indirizzo') + " " + studente.mail2 + t('non_valido'));
              return;
            }

            if (studente.mail != '') await sendMail(username, token, this.mail, this.mailName, studente.mail, studente.nome + ' ' + studente.cognome, file ? this.filePath.name : '', subject, body);
            if (studente.mail2 != '') await sendMail(username, token, this.mail, this.mailName, studente.mail2, studente.nome + ' ' + studente.cognome, file ? this.filePath.name : '', subject, body);

            this.setState({waitDialogVisible: false})
            this.setState({sendMailVisible: false})
        }}  
      />

      <SendNotificationWidget 
          ref={this.sendNotificationRef}
          show={this.state.sendNotificationVisible} 
          onClose={() => this.setState({sendNotificationVisible: false})}
          onSend={async (subject, body, bodyFull) => {
            
            const cookies = new Cookies();
            const username = cookies.get('username', { path: '/' });
            const token = cookies.get('token', { path: '/' });

            await addNotification(username, token, 'STUDENTE', this.state.notificationUser, subject, body, bodyFull, 0);

            this.setState({waitDialogVisible: false})
            this.setState({sendNotificationVisible: false})
        }}  
      />
        
        <NewStudentWidget 
          key={Math.random()}
          visible={this.state.newStudentVisible}
          onDone={() => {
            this.reload();
            this.setState({ newStudentVisible: false });
          }} />

        <WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index}/>
        </LoadingOverlay>
      </>
    );
  }
}

